import React from "react";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

import Button from "../../../../../components/elements/Button";

import ProjectBlocksContainerEditor from "./blocks/ProjectBlocksContainerEditor";

import WorkspaceEditorsManager from "./WorkspaceEditorsManager";
import ValidationEditor from "./ValidationEditor";

import FeedbackEditor from "./FeedbackEditor";
import HintsEditor from "./HintsEditor";
import SolutionEditorsManager from "./SolutionEditorsManager";
import SolutionEditor from "./SolutionEditorsManager";

export default function StepEditorCard({

                                           project,

                                           step,

                                           path,

                                           updateAtPath,

                                           onDelete,

                                           canDelete

                                       }){



    return(

        <div className="border rounded-md bg-white p-8 flex flex-col gap-10">

            <div className="flex justify-between items-center">

                <h2>

                    Step

                </h2>

                <Button
                    onClick={onDelete}
                    disabled={!canDelete}
                >
                    <FontAwesomeIcon icon={faTrash}/>
                </Button>

            </div>

            <ProjectBlocksContainerEditor

                title="Instruction"

                container={step.instruction}

                path={[...path,"instruction"]}

                updateAtPath={updateAtPath}

            />

            <WorkspaceEditorsManager

                workspace={project.workspace}

                editors={step.editors}

                path={[...path,"editors"]}

                updateAtPath={updateAtPath}

            />

            <ValidationEditor
                workspace={project.workspace}
                step={step}
                path={path}
                updateAtPath={updateAtPath}
            />

            <FeedbackEditor

                feedback={step.feedback}

                path={[...path,"feedback"]}

                updateAtPath={updateAtPath}

            />

            <HintsEditor

                hints={step.hints}

                path={[...path,"hints"]}

                updateAtPath={updateAtPath}

            />

            <SolutionEditor
                workspace={project.workspace}
                solution={step.solution}
                path={[...path, "solution"]}
                updateAtPath={updateAtPath}
            />

            <ProjectBlocksContainerEditor

                title="Explain"

                container={step.explain}

                path={[...path,"explain"]}

                updateAtPath={updateAtPath}

            />

        </div>

    );

}